export const zhCN = {
  lang: 'zh-CN',
  country: 'CN',
  flag: '🇨🇳',
  currency: '¥',

  app: {
    sidebar: {
      dashboard: '仪表盘',
      transactions: '交易记录',
      pots: '账户',
      receipts: '收据',
      reports: '报表',
      categories: '分类',
      tags: '标签',
      budgets: '预算',
      recurring: '定期交易',
      settings: '设置',
      darkMode: '深色模式',
      lightMode: '浅色模式',
      logout: '退出登录',
    },
    common: {
      loading: '加载中...',
      save: '保存',
      cancel: '取消',
      confirmTitle: '确认',
      delete: '删除',
      edit: '编辑',
      create: '创建',
      search: '搜索',
      filter: '筛选',
      export: '导出',
      type: '类型',
      category: '分类',
      date: '日期',
      amount: '金额',
      description: '描述',
      actions: '操作',
      income: '收入',
      expense: '支出',
      name: '名称',
      color: '颜色',
      confirmDelete: '确定要删除吗？',
      noResults: '未找到结果',
      status: '状态',
      error: '错误',
      success: '成功',
      page: '页',
      of: '共',
      showing: '显示',
      viewDetails: '查看详情',
      tags: '标签',
      receipt: '收据',
      receiptAttached: '已附收据',
    },
    categoryLabels: {
      food: '餐饮',
      transport: '交通',
      shopping: '购物',
      entertainment: '娱乐',
      health: '健康',
      education: '教育',
      utilities: '水电账单',
      housing: '住房',
      travel: '旅行',
      other: '其他',
      salary: '工资',
      investment: '投资',
      freelance: '自由职业',
      gift: '礼物',
    },
    tags: {
      loading: '正在加载标签...',
      error: '无法加载标签，请重试。',
      title: '标签',
      subtitle: '创建标签来整理和筛选您的交易',
      newTag: '新建标签',
      noTags: '暂无标签',
      noTagsDescription: '当您在消息中使用 #标签 时，标签会自动创建，您也可以在这里手动创建。',
      createFirst: '创建第一个标签',
      howToUse: '如何使用标签',
      howToUseDescription: '通过 WhatsApp 在交易中添加 #标签。例如："午餐 35元 #工作 #午餐"。标签可以帮助您筛选和分析消费。',
      form: {
        name: '标签名称',
        namePlaceholder: '工作、旅行、午餐...',
        nameHint: '将转换为小写且不含空格',
        color: '颜色',
      },
      stats: {
        title: '统计',
        created: '已创建标签',
        totalUsage: '使用总次数',
        mostUsed: '最常用',
        unused: '未使用',
      },
      confirmDelete: '删除标签',
      deleteWarning: '确定要删除标签',
      deleteUsageWarning: '此标签在 {count} 笔交易中使用，删除后将从这些交易中移除。',
    },
    pots: {
      title: '账户',
      subtitle: '按货币将资金整理到不同账户',
      loading: '正在加载账户...',
      error: '无法加载账户，请重试。',
      errorTitle: '加载账户失败',
      newPot: '新建账户',
      editPot: '编辑账户',
      noPots: '暂无账户',
      noPotsDescription: '创建账户来按货币或目标整理您的资金。',
      createFirst: '创建第一个账户',
      setDefault: '设为默认',
      transactions: '笔交易',
      confirmDelete: '删除账户',
      confirmDeleteMessage: '确定要删除账户',
      deleteWarning: '此账户有 {count} 笔交易，将被移至默认账户。',
      form: {
        name: '名称',
        namePlaceholder: '例如：应急储备金',
        description: '描述（可选）',
        descriptionPlaceholder: '这个账户的用途是什么？',
        currency: '货币',
        color: '颜色',
      },
    },
    transactions: {
      loading: '正在加载交易...',
      title: '交易记录',
      subtitle: '管理您的收入和支出',
      searchPlaceholder: '搜索描述、商户...',
      showing: '显示 {count}/{total} 笔交易',
      confirmDelete: '确定要删除此交易吗？',
      filters: {
        filters: '筛选',
        dateStart: '开始日期',
        dateEnd: '结束日期',
        startDate: '开始日期',
        endDate: '结束日期',
        minAmount: '最小金额',
        maxAmount: '最大金额',
      },
      table: {
        description: '描述',
        category: '分类',
        date: '日期',
        amount: '金额',
        receipt: '收据',
        actions: '操作',
      },
      viewReceipt: '查看收据',
      modal: {
        editTitle: '编辑交易',
        detailsTitle: '交易详情',
        merchant: '商户',
        description: '描述',
        tags: '标签',
        receipt: '收据',
        receiptAttached: '已附收据',
        createCategory: '创建新分类',
      },
    },
    dashboard: {
      title: '仪表盘',
      subtitle: '您的财务概览',
      period: {
        week: '本周',
        month: '本月',
        year: '本年',
      },
      cards: {
        income: '收入',
        expense: '支出',
        expenses: '支出',
        balance: '余额',
        transactions: '交易',
      },
      charts: {
        spending: '分类支出',
        trend: '趋势',
        byCategory: '分类支出',
      },
      recent: '最近交易',
      viewAll: '查看全部',
      topCategories: '热门分类',
      items: '项',
      loading: '正在加载仪表盘...',
    },
    settings: {
      title: '设置',
      subtitle: '管理您的个人资料和偏好设置',
      profile: {
        title: '个人资料',
        phone: '电话',
        phoneVerified: '已验证',
        phoneHint: '电话用于身份验证，无法在此处更改。',
        name: '姓名',
        namePlaceholder: '您的姓名',
        email: '邮箱',
        emailPlaceholder: 'your@email.com',
        emailHint: '用于接收报表和通知。',
        verified: '已验证',
      },
      preferences: {
        title: '偏好设置',
        language: '语言',
        languageHint: '用于 WhatsApp 消息和报表的语言。',
        timezone: '时区',
      },
      subscription: {
        title: '订阅',
        plan: '套餐',
        status: {
          active: '有效',
          trialing: '试用中',
          pastDue: '待付款',
          past_due: '待付款',
          canceled: '已取消',
          expired: '已过期',
        },
        trialEnds: '试用结束于',
        trialEndsAt: '试用结束于',
        nextBilling: '下次扣费',
        upgrade: '升级套餐',
        support: '联系客服',
        contactSupport: '联系客服',
        cancel: '取消订阅',
        noSubscription: '暂无有效订阅',
        noSubscriptionDesc: '订阅套餐以解锁全部功能。',
        viewPlans: '查看套餐',
        plans: {
          free: '免费版',
          basic: '基础版',
          starter: '入门版',
          pro: '专业版',
          professional: '专业版',
          enterprise: '企业版',
          vip: 'VIP',
        },
      },
      account: {
        title: '账户信息',
        id: '账户 ID',
        createdAt: '账户创建于',
      },
      saveChanges: '保存更改',
      loading: '正在加载设置...',
      error: '加载设置失败',
      errorDesc: '无法加载您的信息，请重试。',
    },
    budgets: {
      title: '预算',
      subtitle: '按类别设置支出限额',
      loading: '正在加载预算...',
      error: '加载预算失败',
      errorDesc: '无法加载您的预算，请重试。',
      newBudget: '新建预算',
      noBudgets: '暂无预算',
      noBudgetsDesc: '创建预算以按类别控制支出并接收提醒。',
      createFirst: '创建第一个预算',
      period: {
        monthly: '月度',
        yearly: '年度',
      },
      status: {
        safe: '预算内',
        warning: '接近限额',
        danger: '超出限额！',
      },
      spent: '已花费',
      limit: '限额',
      remaining: '剩余',
      exceeded: '超出',
      summary: {
        totalBudgeted: '预算总额',
        totalSpent: '支出总额',
        overBudget: '超出预算',
        budget: '个预算',
        budgets: '个预算',
      },
      tips: {
        title: '预算管理建议',
        tip1: '从花费最多的类别开始',
        tip2: '根据历史记录设置合理的限额',
        tip3: '使用 80% 提醒在超支前采取行动',
        tip4: '每月检查并调整预算',
      },
      confirmDelete: '删除预算',
      confirmDeleteMsg: '确定要删除此预算吗',
      form: {
        newBudget: '新建预算',
        editBudget: '编辑预算',
        budgetName: '预算名称',
        budgetNamePlaceholder: '例如：每月餐饮、交通...',
        category: '类别（可选）',
        allExpenses: '所有支出',
        limit: '限额',
        period: '周期',
        alertThreshold: '提醒阈值',
        alertDescription: '当您的支出达到此限额百分比时，您将收到通知。',
        preview: '预览',
        save: '保存',
        create: '创建',
      },
    },
    categories: {
      title: '类别',
      subtitle: '管理您的收入和支出类别',
      loading: '正在加载类别...',
      error: '加载类别失败',
      errorDesc: '无法加载您的类别，请重试。',
      newCategory: '新建类别',
      myCategories: '我的类别',
      systemCategories: '系统类别',
      systemCategoriesDesc: '这些是默认类别，无法编辑。',
      noCustomCategories: '暂无自定义类别',
      noCustomCategoriesDesc: '创建自定义类别以更好地组织您的财务。',
      createFirst: '创建第一个类别',
      type: {
        income: '收入',
        expense: '支出',
      },
      deductible: '可抵扣',
      confirmDelete: '删除类别',
      confirmDeleteMsg: '确定要删除此类别吗',
      deleteWarning: '现有交易将被移至"其他"。',
      form: {
        newCategory: '新建类别',
        editCategory: '编辑类别',
        categoryName: '类别名称',
        categoryNamePlaceholder: '例如：餐饮、交通...',
        type: '类型',
        icon: '图标',
        colour: '颜色',
        preview: '预览',
        taxDeductible: '可抵扣税款',
        save: '保存',
        create: '创建',
      },
    },
    receipts: {
      title: '收据',
      subtitle: '查看和管理您的税务凭证',
      loading: '正在加载收据...',
      error: '加载收据失败',
      errorDesc: '无法加载您的收据，请重试。',
      status: {
        all: '所有状态',
        processing: '处理中',
        completed: '已完成',
        failed: '失败',
        manual_review: '人工审核',
      },
      year: {
        all: '所有年份',
      },
      stats: {
        total: '总计',
        completed: '已完成',
        processing: '处理中',
        failed: '失败',
      },
      noReceipts: '暂无收据',
      noReceiptsFiltered: '未找到收据',
      noReceiptsDesc: '通过 WhatsApp 发送收据照片开始使用',
      noReceiptsFilteredDesc: '调整筛选条件以查看更多收据',
      showing: '显示 {count} / {total} 张收据',
      page: '第 {current} 页，共 {total} 页',
    },
    recurring: {
      title: '定期交易',
      subtitle: '自动化您的固定支出和收入',
      loading: '正在加载定期交易...',
      error: '加载定期交易失败',
      errorDesc: '无法加载您的定期交易，请重试。',
      newRecurring: '新建定期交易',
      noRecurring: '暂无定期交易',
      noRecurringDesc: '设置自动重复的交易，如房租、订阅或工资。',
      createFirst: '创建第一个定期交易',
      active: '活跃',
      paused: '已暂停',
      activeCount: '活跃 ({count})',
      pausedCount: '已暂停 ({count})',
      next: '下次',
      summary: {
        monthlyExpenses: '月支出',
        monthlyIncome: '月收入',
        netMonthly: '月净额',
      },
      frequency: {
        daily: '每日',
        weekly: '每周',
        monthly: '每月',
        yearly: '每年',
      },
      dayOf: {
        everyDay: '每天',
        every: '每',
        dayOfMonth: '每月 {day} 日',
        annually: '每年',
      },
      actions: {
        pause: '暂停',
        activate: '激活',
        processNow: '立即处理',
      },
      tips: {
        title: '关于定期交易',
        tip1: '交易将在预定日期自动创建',
        tip2: '您可以暂停而不删除',
        tip3: '用于固定支出如房租、电费、网费',
        tip4: '也适用于收入如工资',
      },
      confirmDelete: '删除定期交易',
      confirmDeleteMsg: '确定要删除此定期交易吗',
      deleteWarning: '已创建的交易不会受到影响。',
      form: {
        newRecurring: '新建定期交易',
        editRecurring: '编辑定期交易',
        description: '描述',
        descriptionPlaceholder: '例如：房租、Netflix、工资...',
        amount: '金额',
        category: '类别',
        selectCategory: '选择类别',
        selectPot: '选择账户（可选）',
        frequencyLabel: '频率',
        dayOfMonth: '每月几号',
        dayOfWeek: '星期几',
        day: '日',
        startDate: '开始日期',
        endDate: '结束日期（可选）',
        preview: '预览',
        save: '保存',
        create: '创建',
        daysOfWeek: {
          monday: '星期一',
          tuesday: '星期二',
          wednesday: '星期三',
          thursday: '星期四',
          friday: '星期五',
          saturday: '星期六',
          sunday: '星期日',
        },
      },
    },
    reports: {
      title: '税务报告',
      subtitle: '年度报税摘要',
      loading: '正在加载报告...',
      error: '加载报告失败',
      errorDesc: '无法加载您的报告，请重试。',
      year: {
        all: '所有年份',
      },
      noReports: '暂无报告',
      noReportsFiltered: '未找到报告',
      noReportsDesc: '您的税务报告将在每年年底自动生成。',
      noReportsFilteredDesc: '{year} 年暂无报告。',
      generatedOn: '生成于',
      card: {
        income: '收入',
        expenses: '支出',
        deductible: '可抵扣',
        balance: '余额',
      },
      country: {
        BR: '巴西',
        GB: '英国',
      },
      tips: {
        title: '关于税务报告',
        desc: '报告在每个财年结束时自动生成。',
        tip1: '巴西：财年为 1 月至 12 月',
        tip2: '英国：财年为 4 月至次年 3 月',
      },
    },
  },

  nav: {
    pricing: '价格',
    features: '功能',
    howItWorks: '使用方式',
    login: '登录',
  },

  hero: {
    badge: '零摩擦的财务管理',
    title: '用 WhatsApp 管理您的财务',
    subtitle: '发送消息、照片或语音，AI 自动记录、分类并整理一切。',
    cta: '免费开始',
    ctaSubtext: '14天免费试用，无需信用卡',
    ukOnly: '目前仅支持英国手机号码',
    trustedBy: '像发消息一样简单',
  },

  howItWorks: {
    title: '使用方式',
    subtitle: '三种记录方式，零负担。',
    step1: {
      icon: '💬',
      title: '文字',
      description: '自然输入："50 午餐"、"+500 工资"、"昨天打车 是工作相关"',
      example: '"85 超市"',
    },
    step2: {
      icon: '📸',
      title: '照片',
      description: '拍摄收据照片，OCR 自动提取金额、商户、税号和商品明细。',
      example: '收据照片',
    },
    step3: {
      icon: '🎤',
      title: '语音',
      description: '录制语音描述消费，我们会自动转录并记录。',
      example: '"在加油站花了200"',
    },
  },

  features: {
    title: '不只是记账工具',
    subtitle: '强大功能，简洁界面',
    list: [
      {
        icon: 'wallet',
        title: '账户（Pots）',
        description: '按账户整理：招商银行、支付宝、项目X。每个账户可设不同货币。',
        command: '"创建账户 招商银行"',
      },
      {
        icon: 'target',
        title: '预算',
        description: '按分类设置限额。达到80%时自动提醒。',
        command: '"预算 500 餐饮"',
      },
      {
        icon: 'hash',
        title: '标签',
        description: '使用 #标签 整理："50 打车 #客户 #项目x"',
        command: '"我的 #工作 支出"',
      },
      {
        icon: 'repeat',
        title: '定期交易',
        description: '设置固定支出。房租、会员费、工资——自动记录。',
        command: '"创建定期 1500 房租"',
      },
      {
        icon: 'globe',
        title: '多币种',
        description: '人民币、美元、欧元、英镑。汇率实时更新，仪表盘统一显示。',
        command: '"50 美元 午餐 账户 旅行"',
      },
      {
        icon: 'layout',
        title: '网页仪表盘',
        description: '图表、筛选、导出。所有记录都可在网页端查看。',
        command: 'keepnota.com',
      },
    ],
  },

  commands: {
    title: '快捷命令',
    subtitle: '自然对话，无需记忆。',
    list: [
      { cmd: '50 咖啡', desc: '记录50元支出' },
      { cmd: '+2000 兼职', desc: '记录收入' },
      { cmd: '汇总', desc: '显示本月汇总' },
      { cmd: '我的账户', desc: '列出您的账户' },
      { cmd: '删除上一条', desc: '删除最近一笔交易' },
      { cmd: '帮助', desc: '列出所有命令' },
    ],
  },

  audience: {
    title: '为追求简单的人而生',
    subtitle: '如果您会用 WhatsApp，就会用 KeepNota',
    personas: [
      {
        icon: 'briefcase',
        title: '自由职业者和个体户',
        description: '分开个人和工作账目。清楚了解收支情况。',
      },
      {
        icon: 'user',
        title: '个人理财',
        description: '告别电子表格。消费发生时即刻记录。',
      },
      {
        icon: 'users',
        title: '情侣和家庭',
        description: '共享账户。每个人都能记录，所有人都能查看。',
      },
      {
        icon: 'plane',
        title: '旅行者',
        description: '自动多币种转换。在任何地方消费，统一换算。',
      },
    ],
  },

  comparison: {
    title: '为什么选择 KeepNota？',
    subtitle: '与其他方式对比',
    vsSpreadsheet: {
      title: 'vs 电子表格',
      points: [
        '无需打开电脑',
        '即时记录',
        '自动分类',
        '拍张收据照片 = 自动填写',
      ],
    },
    vsApps: {
      title: 'vs 理财App',
      points: [
        '在 WhatsApp 中使用（每天都在用）',
        '零摩擦——只需发消息',
        '收据OCR识别已内置',
        '没有烦人的通知',
      ],
    },
    vsManual: {
      title: 'vs 手动记录',
      points: [
        '永远不会忘记记账',
        '不方便打字时用语音',
        '历史记录随时可查',
        '自动生成报表',
      ],
    },
  },

  taxBonus: {
    title: '额外福利：为报税做好准备',
    subtitle: '到报税季时，您的数据已经整理好了',
    points: [
      '分类对应税务抵扣项目',
      '自动从收据中获取税号',
      '年度报表可导出',
      '用标签标记可抵扣支出',
    ],
  },

  pricing: {
    title: '价格套餐',
    subtitle: '免费开始。需要时再升级。',
    monthly: '/月',
    yearly: '/年',
    savePercent: '省20%',
    basic: {
      name: '基础版',
      price: '19.90',
      features: [
        '每月30张收据照片',
        '每月20条语音',
        '无限文字消息',
        '基础仪表盘和图表',
        '月度报表',
        '导出CSV',
        '收据保留：1年',
      ],
    },
    pro: {
      name: '专业版',
      price: '39.90',
      popular: '最受欢迎',
      features: [
        '无限照片和语音',
        '基础版所有功能 +',
        '高级图表和筛选',
        '月度对比分析',
        '导出PDF',
        '年度报表（报税用）',
        '优先客服支持',
        '收据保留：2年',
      ],
    },
    cta: '免费开始',
    trial: '14天免费试用，随时取消',
  },

  referral: {
    title: '推荐有礼',
    subtitle: '分享给朋友，获得免费使用天数',
    tiers: [
      { range: '1-5 次推荐', reward: '每次7天免费' },
      { range: '6-15 次推荐', reward: '每次10天免费' },
      { range: '16+ 次推荐', reward: '14天 + 额外积分' },
    ],
    cta: '了解更多',
  },

  faq: {
    title: '常见问题',
    items: [
      {
        q: '需要下载App吗？',
        a: '不需要！完全通过 WhatsApp 使用。只需保存我们的号码就可以开始记账。我们还有网页端可以查看图表和报表。',
      },
      {
        q: '我的数据安全吗？',
        a: '安全！我们使用端到端加密、安全服务器，并遵守数据保护法规。您可以随时导出或删除您的数据。',
      },
      {
        q: '可以随时取消吗？',
        a: '当然可以！没有合约约束。随时可以在 WhatsApp 中输入"取消"来取消订阅。取消后您的数据将保留30天。',
      },
      {
        q: '适合个体户和自由职业者吗？',
        a: '非常适合！使用账户（Pots）分开个人和工作支出，用标签标记客户，全面掌控收支情况。',
      },
      {
        q: '收据OCR是如何工作的？',
        a: '发送收据照片，我们的AI自动提取：总金额、商户名、税号、日期甚至商品明细。只需确认即可。',
      },
      {
        q: '支持多种货币吗？',
        a: '支持！我们支持人民币、美元、欧元和英镑。每个账户可以设置不同货币，仪表盘会按您的主要货币统一显示。',
      },
    ],
  },

  cta: {
    title: '今天就开始管理您的财务',
    subtitle: '14天免费试用。无需信用卡。随时取消。',
    button: '在 WhatsApp 上联系我们',
    secondary: '观看演示',
  },

  footer: {
    copyright: '© 2025 KeepNota by Fig and Rosa Ltd. 保留所有权利。',
    terms: '使用条款',
    privacy: '隐私政策',
    tagline: '通过 WhatsApp 管理财务',
  },

  privacy: {
    title: '隐私政策',
    lastUpdate: '最后更新：2024年12月',
    intro: 'KeepNota（"我们"或"服务"）重视用户隐私。本隐私政策说明我们如何收集、使用和保护您的信息。',
    sections: [
      {
        title: '1. 我们收集的数据',
        content: `当您使用 KeepNota 时，我们收集以下数据：
• **电话号码**：用于身份识别和 WhatsApp 通信
• **发送的消息**：您发送的文字、语音和收据图片
• **提取的数据**：从收据中处理的金额、分类和信息
• **使用数据**：访问时间和服务交互记录`,
      },
      {
        title: '2. 我们如何使用您的数据',
        content: `我们使用您的数据来：
• 处理和整理您的收据
• 生成支出报表和图表
• 识别可抵扣税款的支出
• 改进我们的服务和AI算法
• 发送关于您账户和服务的通知`,
      },
      {
        title: '3. 存储和安全',
        content: `您的数据安全存储：
• 传输加密（HTTPS/TLS）
• 存储在安全服务器
• 仅限自动化系统访问
• 定期备份和数据冗余`,
      },
      {
        title: '4. 数据共享',
        content: `**我们不出售您的数据。** 我们仅与以下方共享：
• **服务提供商**：支付处理（Stripe）、存储（AWS）
• **AI/ML**：Google（Gemini）用于图像和文字处理——数据匿名化
• **法律义务**：法律或法院命令要求时`,
      },
      {
        title: '5. 您的权利',
        content: `您有权：
• **访问**：请求您数据的副本
• **更正**：更正不准确的数据
• **删除**：请求删除您的数据
• **可携性**：以结构化格式接收您的数据
• **撤回**：随时撤回同意

如需行使您的权利，请通过 WhatsApp 或邮件联系我们：privacidade@keepnota.com`,
      },
      {
        title: '6. 数据保留',
        content: `在您账户有效期间，我们会保留您的数据。取消后：
• 财务数据：保留5年（税务义务）
• 收据图片：30天内删除
• 账户数据：30天内删除`,
      },
      {
        title: '7. 联系方式',
        content: `如有隐私相关问题：
• 邮箱：privacidade@keepnota.com
• WhatsApp：发送"隐私"至我们的号码`,
      },
    ],
  },

  feedback: {
    title: '提交反馈',
    subtitle: '您的意见帮助我们改进 KeepNota',
    typeLabel: '反馈类型',
    types: {
      general: '一般反馈',
      feature_request: '功能建议',
      bug: 'Bug/错误',
      complaint: '投诉',
      praise: '表扬',
      account_deletion: '删除账户',
    },
    messageLabel: '您的留言',
    messagePlaceholder: '告诉我们您的想法...',
    ratingLabel: '评分（可选）',
    nameLabel: '您的姓名（可选）',
    namePlaceholder: '我们如何称呼您？',
    emailLabel: '邮箱（可选）',
    emailPlaceholder: 'your@email.com',
    emailHint: '用于回复您的反馈',
    submit: '提交反馈',
    errors: {
      messageRequired: '请填写留言',
      messageTooShort: '留言太短（至少10个字符）',
      submitFailed: '提交失败，请重试。',
    },
    success: {
      title: '反馈已提交！',
      message: '感谢您分享您的意见。我们会认真查看。',
    },
    backToHome: '返回首页',
  },

  terms: {
    title: '使用条款',
    lastUpdate: '最后更新：2024年12月',
    intro: '使用 KeepNota 即表示您同意本使用条款。请仔细阅读。',
    sections: [
      {
        title: '1. 关于服务',
        content: `KeepNota 是通过 WhatsApp 整理收据和支出的服务。我们提供：
• 通过照片、语音或文字自动处理收据
• 支出分类和整理
• 支出报表和图表
• 可抵扣税款支出识别

服务按"现状"提供，可能随时修改。`,
      },
      {
        title: '2. 注册和账户',
        content: `使用 KeepNota：
• 您必须年满18岁
• 提供真实信息
• 保持电话号码更新
• 不与他人共享账户

您对账户中的所有活动负责。`,
      },
      {
        title: '3. 可接受的使用',
        content: `您同意不：
• 将服务用于非法目的
• 发送冒犯性、诽谤性或非法内容
• 尝试访问其他用户的系统或数据
• 使用未经授权的机器人或自动化工具
• 转售或再分发服务`,
      },
      {
        title: '4. 付款和订阅',
        content: `• 我们提供14天免费试用
• 试用结束后按月收费
• 通过 Stripe（信用卡）处理付款
• 可随时取消
• 不退还部分使用期间的费用`,
      },
      {
        title: '5. 知识产权',
        content: `• KeepNota 及其组件归 Figrosa 所有
• 您保留对您数据和收据的所有权
• 我们授予您使用服务的有限许可
• 您授予我们处理您数据的必要许可`,
      },
      {
        title: '6. 责任限制',
        content: `• KeepNota 不能替代会计或税务建议
• 我们不保证收据处理绝对准确
• 我们不对基于服务做出的税务决定负责
• 我们的责任限于您支付的服务费用`,
      },
      {
        title: '7. 取消',
        content: `您可以随时取消：
• 通过 WhatsApp 发送"取消"
• 在网页端访问您的账户
• 访问权限持续到付费期结束
• 您的数据将按隐私政策删除`,
      },
      {
        title: '8. 条款变更',
        content: `我们可能随时修改本条款。我们会通过以下方式通知您：
• WhatsApp 消息
• 邮件（如已注册）
• 网页端公告

继续使用即表示接受变更。`,
      },
      {
        title: '9. 联系方式',
        content: `如有条款相关问题：
• 邮箱：suporte@keepnota.com
• WhatsApp：发送"帮助"至我们的号码`,
      },
    ],
  },
};
